import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import TariffSpeedSelector from '~/src/features/request/components/TariffSpeedSelector';

export const SWideContainer = styled(WideContainer)`
    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 100%;
        padding: 0;
        margin: 0;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background: radial-gradient(222.83% 926.66% at 152.41% -92.42%, ${COLORS.BgSurface} 20.17%, ${COLORS.ButtonSecondary} 77.02%);
    background-color: ${COLORS.BgSurface};
`;

export const Inner = styled.div<{ imgSrc: string }>`
    width: 100%;
    height: 100%;
    align-items: flex-start;

    background-image: url(${({ imgSrc }) => imgSrc});
    background-repeat: no-repeat;
    background-size: auto 726px;
    background-position: right 64px top 101px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        background-size: auto 530px;
        background-position: right 40px top 74px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        background-size: auto 400px;
        background-position: right 20px top 55px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        background-size: auto 534px;
        background-position: center 50px;
        align-items: flex-end;
    }
    
    @media (max-width: 575px) {
        background-size: 85% auto;
    }
`;

export const STariffSpeedSelector = styled(TariffSpeedSelector)`
    margin-top: 165px;
    max-width: 608px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        max-width: 592px;
        margin-top: 40px;
    }
    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: 456px;
        margin-top: 24px;
    }
    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 100%;
    }
`;
